export const QUEUE_FOR_REMOVAL_FROM_ORDER_DATA_VALUE = '__QUEUE_FOR_REMOVAL_FROM_ORDER_DATA__';
export const QUEUE_FOR_REMOVAL_FROM_ORDER_DATA_LABEL = '— None —';
export const INSTANT_REMOVAL_FROM_ORDER_DATA_VALUE = '__INSTANT_REMOVAL_FROM_ORDER_DATA_VALUE__';
export const INSTANT_REMOVAL_FROM_ORDER_DATA_LABEL = '— None —';

function removeProps<T extends Record<string, unknown>>(data: T, value: string, label: string): T {
    const newData = structuredClone(data);
    let hasChanges = false;

    const removeRecursively = (obj: Record<string, any>) => {
        for (const key in obj) {
            const val = obj[key];

            if (val === value || val === label) {
                delete obj[key];
                hasChanges = true;
            } else if (typeof val === 'object' && val !== null && !Array.isArray(val)) {
                removeRecursively(val);
            }
        }
    };

    removeRecursively(newData);

    if (!hasChanges) {
        return data;
    }

    return newData;
}

export function removeQueuedPropsFromOrderData<T extends Record<string, unknown>>(data: T): T {
    return removeProps(data, QUEUE_FOR_REMOVAL_FROM_ORDER_DATA_VALUE, QUEUE_FOR_REMOVAL_FROM_ORDER_DATA_LABEL);
}

export function removeInstantPropsFromOrderData<T extends Record<string, unknown>>(data: T): T {
    return removeProps(data, INSTANT_REMOVAL_FROM_ORDER_DATA_VALUE, INSTANT_REMOVAL_FROM_ORDER_DATA_LABEL);
}
